import api from '@/services/api';
const ENTITY_ENDPOINT = 'entidades';

export class EntidadesService {
  /**
   * Obtiene todos los entidades con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los entidades con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Busca entidades por nombre o criterio
   * @param {string} query - Término de búsqueda
   * @param {Object} additionalParams - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async search(query, additionalParams = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/`, {
      params: {
        Nombre: query,
        ...additionalParams,
      },
    });
  }

  /**
   * Obtiene un entidades por su ID
   * @param {string|number} id - ID del entidades
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo entidades
   * @param {Object} entidades - Datos del entidades a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(entidades) {
    return await api.post(`/${ENTITY_ENDPOINT}`, entidades);
  }

  /**
   * Actualiza un entidades existente
   * @param {string|number} id - ID del entidades
   * @param {Object} entidades - Datos del entidades a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, entidades) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, entidades);
  }

  /**
   * Elimina un entidades
   * @param {string|number} id - ID del entidades
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default EntidadesService;
